import { HStack } from "@chakra-ui/react";
import { Link } from "@components/ui-kit";
import { AbraFlexiExportedIcon } from "@src/components/modules/common/exports/abraflexi/AbraFlexiExportedIcon";
import { DocumentExportIndicator } from "@src/components/modules/common/exports/document-export-indicator";
import { EmailLogs } from "@src/components/modules/invoices/EmailLogs";
import type { ProformaInvoice } from "../../../Models.types";

type ProformaNoProps = {
  readonly row: Pick<
    ProformaInvoice,
    "id" | "invoice_no" | "abraflexi_exported" | "documentExports" | "emailLogs"
  >;
};

export function ProformaNo({ row }: ProformaNoProps) {
  return (
    <HStack spacing="0">
      <Link
        href={{
          pathname: "/invoices/proforma-invoices/detail",
          query: { id: row.id },
        }}
      >
        {row.invoice_no}
      </Link>
      {row.abraflexi_exported && <AbraFlexiExportedIcon />}
      <DocumentExportIndicator documentExports={row.documentExports} />
      <EmailLogs
        type="outgoingProformaInvoice"
        logs={row.emailLogs.map((log) => ({
          ...log,
          sent_at: new Date(log.sent_at),
        }))}
      />
    </HStack>
  );
}
